<script setup>
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { getWorkflows } from '@/services/workflowService.js'
import { getCampaign } from '@/services/campaignService.js'
import { formatCampaignAttribute } from '@/libs/utils/translations.js'

import CompiledPollList from '@/components/CMB/CMB_CompiledPoll.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { useSummaryCampaign } from '@/services/store.js'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import TranslationProvider from '@/provider/translations.js'

library.add(faArrowLeft)

const route = useRoute()
const props = defineProps(['cId', 'updatePageTitle'])
const campaign = ref(null)
const workflow = ref(null)
const pollTemplate = ref(null)
const summaryCampaign = useSummaryCampaign()

onMounted(async () => {
  campaign.value = await getCampaign(props.cId, {poll: 1})
  pollTemplate.value = campaign.value['poll']

  if (!campaign.value.attributes) {
    campaign.value.attributes = {}
  }

  workflow.value = await getWorkflows('campaign').then((result) => {
    return result.filter(item => item.key === campaign.value.workflow)[0]
  })
  props.updatePageTitle('Sommario salvataggio campagna - ' + campaign.value.title)
})
</script>

<template>
  <div class="container-fluid px-0" v-if="campaign && workflow && pollTemplate">
    <div class="card">
      <div class="card-body p-0 m-3">
        <div class="alert alert-success">Salvataggio avvenuto con successo</div>

        <div class="table-responsive pt-2 pb-4" v-if="summaryCampaign.summaryCampaign[props.cId]">
          <table class="table table-sm">
            <tbody>
            <tr>
              <th class="ps-0" scope="col" >Questionari creati</th>
              <td class="text-end pe-0"><span class="badge rounded-pill text-bg-success">{{summaryCampaign.summaryCampaign[props.cId].created}}</span></td>
            </tr>
            <tr>
              <th class="ps-0" scope="col">Questionari saltati (già presenti)</th>
              <td class="text-end pe-0"><span class="badge rounded-pill text-bg-light">{{summaryCampaign.summaryCampaign[props.cId].skipped}}</span></td>
            </tr>
            <tr>
              <th class="border-0 ps-0" scope="col">Questionari non creati (con errori)</th>
              <td class="border-0 text-end pe-0"><span class="badge rounded-pill text-bg-danger">{{summaryCampaign.summaryCampaign[props.cId].errors}}</span></td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="mb-3">
          <label for="template"><b>Template</b></label>
          <p>{{ pollTemplate.title }}</p>
        </div>

        <div class="mb-3">
          <template
            v-if="
              Object.keys(campaign.attributes).length &&
              campaign.attributes.constructor === Object
            "
          >
            <label><b>Attributi</b></label>
            <ul>
              <li v-for="(value, attribute) in campaign.attributes" :key="attribute">
                <b>{{ TranslationProvider.getTrans(`campaign.attribute.${attribute}`, attribute) }}</b>:
                {{formatCampaignAttribute(attribute, value)}}
              </li>
            </ul>
          </template>
        </div>
        <div class="mb-3">
          <label for="workflow"><b>Workflow</b></label>
          <p>{{ workflow.label }}</p>
        </div>

        <div class="mb-3">
          <label for="title"><b>Titolo campagna</b></label>
          <p>{{ campaign.title }}</p>
        </div>
        <div class="mb-3">
          <label class="form-check-label"><b> Versione template </b></label>
          <p>{{ campaign.pollTemplateRevisionNumber }}</p>
        </div>

        <div class="my-2 text-end">
          <button
            @click="
              $router.push({
                name: 'admin/CMB_Campaign--edit',
                params: { id: campaign.id },
                query: { page: route.query.page },
              })
            "
            class="btn btn-primary"
          >
            Modifica campagna
          </button>
        </div>

        <div>
          <CompiledPollList :campaign-id="campaign.id"> </CompiledPollList>
        </div>
      </div>
    </div>

    <div class="d-flex mt-2">
      <button
        @click="
          $router.push({
            name: 'admin/CMB_Campaign',
            query: { page: route.query.page },
          })
        "
        class="btn btn-outline-secondary"
      >
        <font-awesome-icon icon="fa-arrow-left"></font-awesome-icon>
        Torna alla lista
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
[class*='fa-'] {
  width: 0.9rem;
}
</style>
